import { Icons } from 'assets';
import { AlertProps } from './alert.types';

export const optionsMap: Record<
  AlertProps['mode'],
  {
    icon: keyof typeof Icons;
  }
> = {
  info: {
    icon: 'InformationCircleFilled',
  },
  success: {
    icon: 'CheckCircleFilled',
  },
  warning: {
    icon: 'ExclamationTriangleFilled',
  },
  error: {
    icon: 'CrossCircleFilled',
  },
  super: {
    icon: 'InformationCircleFilled',
  },
};
